<template>
    <div id="sidebar-xl" class="sidebar-outer-container-xl">
        <div class="d-flex flex-column align-items-center">
            <a :href="homePageURL">
                <img src="@/assets/header/logo-text.svg" alt="Revivot logo" width="85" />
            </a>
            <ul class="sidebar-items-container-xl">
                <li class="sidebar-new-order-container-xl ps-0">
                    <router-link id="dashboard-new-project" to="/upload-photos"
                        >+ New Project</router-link
                    >
                </li>
                <li class="mb-3" :class="[projectListClass]">
                    <router-link
                        to="/projects-list"
                        class="text-decoration-none d-flex align-items-center"
                    >
                        <img
                            v-if="checkForActiveProjectList"
                            src="@/assets/sidebar/project-list-icon.svg"
                            alt=""
                            height="18px"
                        />
                        <img
                            v-else
                            src="@/assets/sidebar/project-list-inactive-icon.svg"
                            alt=""
                            height="18px"
                        />
                        <span
                            class="m-left-1"
                            :class="[
                                checkForActiveProjectList
                                    ? 'fw-bold accent-color'
                                    : 'primary-color',
                            ]"
                            >Project List</span
                        >
                    </router-link>
                </li>
                <li class="m-bottom-4 m-top-4" :class="[financeClass]">
                    <router-link
                        to="/finance"
                        class="text-decoration-none d-flex align-items-center"
                    >
                        <img
                            v-if="$route.path === '/finance'"
                            src="@/assets/sidebar/finance-active-icon.svg"
                            alt=""
                            height="18px"
                        />
                        <img v-else src="@/assets/sidebar/finance-icon.svg" alt="" height="18px" />
                        <span
                            :class="[
                                $route.path === '/finance'
                                    ? 'fw-bold accent-color m-left-1'
                                    : 'primary-color m-left-1',
                            ]"
                            >Finance</span
                        >
                    </router-link>
                </li>
            </ul>
        </div>
        <!-- <div id="chat-box"></div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            isChatBoxLoaded: true,
        };
    },
    computed: {
        homePageURL() {
            return `${process.env.VUE_APP_BASE_HOME_PAGE_URL}/dashboard`;
        },
        projectListClass() {
            if (this.$route.path === '/projects-list') {
                return 'sidebar-item-active-xl';
            }
            return 'sidebar-item-inactive-xl';
        },
        financeClass() {
            if (this.$route.path === '/finance') {
                return 'sidebar-item-active-xl';
            }
            return 'sidebar-item-inactive-xl';
        },
        notificationClass() {
            if (this.$route.path === '/notification') {
                return 'sidebar-item-active-xl';
            }
            return 'sidebar-item-inactive-xl';
        },
        checkForActiveProjectList() {
            const path = this.$route.path.split('/');
            if (path.includes('order-results') || path.includes('projects-list')) {
                return true;
            }
            return false;
        },
    },
    inject: ['appBranch'],
    mounted() {
        setTimeout(() => {
            const crispElement = document.getElementsByClassName('crisp-client');

            const clonedCrispElement = crispElement[0].cloneNode(true);
            
            document.getElementById('sidebar-xl').appendChild(clonedCrispElement);

        }, 3000);
    },
    methods: {
        showChatBot() {
            this.$store.commit('TOGGLE_SHOW_CHATBOT', true);
        },

        // async unreadNotification() {
        //     try {
        //         const { status, data } = await baseApiAddress({
        //             method: 'post',
        //             url: '/user/notification/unread-all',
        //         });
        //     } catch (error) {}
        // },

        openChatBox() {
            // $crisp.push(['do', 'chat:show']);/
            // $crisp.push(["do", "chat:open"])
            // let response;

            // try {
            //     response = new Promise((resolve, reject) => {
            //         resolve(smartsupp('chat:open'));
            //         reject('Error Happens');
            //     });
            // } catch (error) {
            //     throw new Error(error);
            // }

            // response.then(() => {
            //     setTimeout(() => {
            //         const smartup = window.$smartsupp.chats.chat.frame;

            //         const smartupFrameContent =
            //             smartup.contentDocument || smartup.contentWindow.document;

            //         const smartupFrameButtons =
            //             smartupFrameContent.body.getElementsByClassName('MuiIconButton-root');

            //         const closeButtonTestIds = ['mobileCloseButton', 'mobileMinimalizeButton'];

            //         for (var i = 0; i < smartupFrameButtons.length; i++) {
            //             if (
            //                 closeButtonTestIds.includes(
            //                     smartupFrameButtons[i].attributes['data-testid'].value
            //                 )
            //             ) {
            //                 smartupFrameButtons[i].addEventListener('click', () => {
            //                     smartsupp('chat:hide');
            //                 });
            //             }
            //         }
            //     }, 200);
            // });
        },
    },
};
</script>

<style lang="scss" scoped>
.sidebar {
    &-outer-container-xl {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        height: calc(100vh - 32px);
        position: fixed;
        top: 16px;
        width: 168px;
        box-shadow: $Dialogue-Shadow;
        border-radius: 16px;
        padding: 24px 16px;
    }
    &-new-order-container-xl {
        @include centerByFlex;
        width: 136px;
        height: 32px;
        border-radius: 56px;
        box-shadow: $Active-Shadow;
        background-color: $Accent-Color;
        margin: 64px auto 56px;
        color: $White-Color;
        font-size: 14px;
        font-weight: bold;
        a {
            color: #fff;
            text-decoration: none;
            text-decoration: none;
        }
    }
    &-items {
        &-container-xl {
            list-style: none;
            width: 168px;
            padding-left: 0;
            text-align: left;
            li {
                padding-left: 16px;
                cursor: pointer;
            }
        }
    }
    &-item {
        &-active-xl {
            border-left: 1px solid $Accent-Color;
            color: $Accent-Color;
            font-weight: bold;
        }
        &-inactive-xl {
            color: $Primary-Text-Color;
        }
    }
}

.get-response-button {
    &:hover {
        cursor: pointer;
    }
}

#chat-box {
    width: 64px;
    height: 64px;
    position: relative;
    margin-bottom: 26px;
    border-radius: 32px;
    background: #182485;
    transition: all 0.3s;
    &:hover {
        opacity: 0.85;
        cursor: pointer;
        transform: scale(1.05, 1.05);
        // .crisp-client .cc-tlyw .cc-kxkl .cc-nsge {
        //     right: 0px !important;
        // }
        // .crisp-client .cc-tlyw .cc-kxkl .cc-nsge {
        //     bottom: 0px !important;
        // }
    }
    &::after {
        content: '';
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 14px;
        height: 14px;
        border-radius: 7px;
        background: greenyellow;
        border: 2px solid white;
    }
}
</style>
